import { useEffect, useState } from "react";
import { useQuery } from "urql";
import { gql } from "@urql/core";

const query = gql`
  query MyQuery($order: [class_user_registrations_order_by!], $id: bigint) {
    class_user_registrations(
      where: { user_id: { _eq: $id } }
      order_by: $order
    ) {
      id
      status
      user_id
      updated_at
      entrance_test_score
      class_registration_id
      class_registration {
        name
        entrance_test_date
        entrance_test_fee
        entrance_test_link
        class_fee
        start_date
        end_date
        id
        class_header {
          name
          id
        }
      }
    }
  }
`;

export default function useStatus(userData) {
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState("Terbaru");

  const orderBy = { order: "updated_at", isAsc: selected };

  const [{ data: tempData, fetching }] = useQuery({
    query: query,
    variables: {
      id: userData.id,
      order: {
        [orderBy.order]: orderBy.isAsc === "Terbaru" ? "desc" : "asc",
      },
    },
  });

  useEffect(() => {
    if (tempData) {
      const temps = [];
      for (const item of tempData.class_user_registrations) {
        temps.push({
          id: item.id,
          status: item.status,
          user_id: item.user_id,
          updated_at: item.updated_at,
          test_score: item.entrance_test_score,
          class_registration_id: item.class_registration_id,
          class_name: item.class_registration.name,
          class_id: item.class_registration.id,
          test_date: item.class_registration.entrance_test_date,
          test_link: item.class_registration.entrance_test_link,
          test_fee: item.class_registration.entrance_test_fee,
          class_fee: item.class_registration.class_fee,
          ch_name: item.class_registration.class_header.name,
          ch_id: item.class_registration.class_header.id,
        });
      }
      setData(temps);
    }
  }, [tempData]);

  const handleChange = (e) => {
    setSelected(e.target.value);
  };

  return {
    data,
    setData,
    selected,
    setSelected,
    orderBy,
    tempData,
    fetching,
    handleChange,
  };
}
